<div class="modal-dialog modal-dialog-centered" role="document">
  <div class="modal-content">
    <div class="modal-body">
      <div class="container-fluid">
        <div class="row loginWrap clear">
          <button type="button" class="close" aria-label="Close" (click)="dismiss()" style="position: absolute; top: 0;right: 11px;z-index:999">
            <span aria-hidden="true">&times;</span>
          </button>
          <div class="col loginImg">
            <div style="text-align:center;font-size:22px;color:white;margin-top:10px;">
              <p>Why Log in?</p>
            </div>
            <div class="introTxt">
              <p *ngIf="!isLogin()">Sign Up To Poke The Villa Owners To Share Exclusive Discounts For Your Date Selection Within 24 Hours!</p>
              <p style="font-size:18px;" *ngIf="isLogin()">We will NOT share your personal information. When you log in, we create an account for you to receive all the personal offers and discounts made by our partners. They get only what you stated in Steps 1 to 3.</p>
            </div>
            <div *ngIf="isLogin()" class="changeAction">
              Not a Vervendo member? <button (click) = "showSignup()">Sign up</button>
            </div>
            <div *ngIf="!isLogin()" class="changeAction">
              Already a Vervendo member? <button id="signIn" (click) = "showSignin()">Sign in</button>
            </div>
          </div>
          <div *ngIf="isLogin() && !forgotPassword" class="col usrFields">
            <h4>Log in</h4>
            <form (ngSubmit)="onInternalSubmit()">
              <input [(ngModel)]="user.email" class="form-control" placeholder="Enter Username" name="username" type="text" required>
              <div class="psswrd">
                <input [(ngModel)]="user.passwd" type="password" placeholder="Enter Password" name="password" class="form-control" required>
              </div>
              <input type="submit" value="Log In">
            </form>
            <div class="cantLogin clear">
              <a (click)="forgotPassword = true" style="cursor: pointer">Can't login?</a>
            </div>
            <div class="otherLogin">
              <span class="lbl">OR</span>
              <span class="socialOpt">Log in with</span>
              <ul class="socialIcn">
                <li class="fcbk"><a (click)= "socialSignin('loginFacebook')"></a></li>
                <li class="ggpl"><a (click)= "socialSignin('loginGoogle')"></a></li>
              </ul>
            </div>
          </div>
          <div *ngIf="forgotPassword" class="col usrFields">
            <h4>Log in</h4>
            <form (ngSubmit)="onForgotPassword()">
              <input [(ngModel)]="user.email" class="form-control" placeholder="Enter Email" name="username" type="text" required>
              <div class="psswrd">
                <input [(ngModel)]="user.passwd" type="password" placeholder="Enter New Password" name="password" class="form-control" required>
                <input [(ngModel)]="confirmedNewPassword" type="password" placeholder="Retype New Password" name="confirmedpassword" required>
              </div>
              <input type="submit" value="Change Password">
            </form>
          </div>
          <div *ngIf="!isLogin() && !forgotPassword" class="col usrFields">
            <h4>Create your account</h4>
            <form id="signupForm" (ngSubmit)="signUp()">
              <input [(ngModel)]="userSignup.email" type="text" placeholder="Email address"  name="email" required>
              <input [(ngModel)]="userSignup.passwd" type="password" placeholder="Password" name="password" required>
              <input [(ngModel)]="userSignup.confirmedPassword" type="password" placeholder="Confirm password" name="confirmedpassword" required>
              <div class="nameSurname clear" style="margin-left:7px;">
                <input [(ngModel)]="userSignup.name" type="text" placeholder="Name" name="name" required>
                <input [(ngModel)]="userSignup.surname"type="text" placeholder="Surname" name="surname" required>
              </div>
              <input type="submit" value="Sign up" style="margin-top:-1px;">
            </form>
            <div class="otherLogin">
              <span class="lbl">OR</span>
              <span class="socialOpt">Sign up with</span>
              <ul class="socialIcn">
                <li class="fcbk"><a (click)= "socialSignup('signupFacebook')"></a></li>
                <li class="ggpl"><a (click)= "socialSignup('signupGoogle')"></a></li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div><!-- /.modal-content -->
</div><!-- /.modal-dialog -->

